const variants = {
    small: {
        fontSize: 'smaller',
    },
}

export const FormLabel = {
    variants,
}
